import React from 'react';
import moment from 'moment';

class DateGridCell extends React.Component {

    formatDate(date) {
        const format = this.props.format || 'MMMM Do YYYY';
        return moment(date).format(format);
    }

    render () {
        return (
            <span className="component-date-grid-cell">
                { this.formatDate(this.props.data) }
            </span>
        )
    }
}

export default DateGridCell;



// WEBPACK FOOTER //
// ./web-app/components/date-grid-cell.jsx